import { safeDefine } from "../../registration/safe-define.js";
import { MenuItemElement } from "../../ui/menu/item.js";
//#region src/define/ui/menu-item.ts
safeDefine(MenuItemElement);
//#endregion
